const ADD_ERROR = 'addError'
const SET_AS_SEEN = 'setAsSeen'
const obj = {
  ADD_ERROR,
  SET_AS_SEEN,
}
export default obj
